module.exports = __webpack_public_path__ + "static/distriteams-ec293c6f013604dd1f67c47f230926e1.jpg";